<div class="error-notice">
  <div class="header-container">
    <app-svg-icon src="./assets/icons/warning-triangle.svg"></app-svg-icon>
    <div class="ep-text-primary-text ep-text-strong-21 header-text">{{ header }}</div>
  </div>
  <div class="ep-text-secondary-text ep-text-regular-14 text">{{ text }}</div>
</div>
